import axios from 'axios';

import { USER_LOGIN_REQUEST, USER_LOGIN_SUCCESS, USER_LOGIN_FAIL, USER_LOGOUT } from '../constants/authConstants';

export const login = (email, password) => async (dispatch) => {

    try {
        dispatch({
            type: USER_LOGIN_REQUEST,
        });

        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const formData = {
            email,
            password
        }

        const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/users/login`, formData, config);

        if (data.token) {

            dispatch({
                type: USER_LOGIN_SUCCESS,
                payload: data,
            });

            localStorage.setItem('access', JSON.stringify(data));
        } else {
            dispatch({
                type: USER_LOGIN_FAIL,
                payload: data.error,
            });
        }
    } catch (error) {
        dispatch({
            type: USER_LOGIN_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const logout = () => (dispatch) => {
    dispatch({ type: USER_LOGOUT });
    localStorage.removeItem('access');
};